import { NavigateLeft, NavigateRight } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classNames from 'classnames';
import { useMemo } from 'react';

import { Button } from '../Button/Button';

import styles from './Pagination.module.scss';
import { PaginationProps } from './Pagination.types';

export const Pagination = ({
  className,
  currentPage,
  pageCount,
  setCurrentPage,
  maxPagesShown = 5,
}: PaginationProps) => {
  const pagesShown = useMemo(() => {
    let minPage = Math.max(0, currentPage - Math.floor(maxPagesShown / 2));
    let maxPage = Math.min(
      pageCount,
      currentPage + Math.floor(maxPagesShown / 2) + (maxPagesShown % 2)
    );
    if (minPage > 0 && maxPage - minPage < maxPagesShown)
      minPage = Math.max(0, maxPage - maxPagesShown);
    if (maxPage < pageCount && maxPage - minPage < maxPagesShown)
      maxPage = Math.min(pageCount, minPage + maxPagesShown);
    return [...new Array(maxPage - minPage)].map((_, idx) => minPage + idx);
  }, [currentPage, pageCount, maxPagesShown]);

  if (pageCount < 2) return null;

  return (
    <div className={classNames(styles.container, className)}>
      <Button
        variant="tertiary"
        size="small"
        disabled={currentPage === 0}
        onClick={() => setCurrentPage(currentPage - 1)}
      >
        <NavigateLeft />
      </Button>
      <div className={styles.numbersContainer}>
        {pagesShown.map(page => (
          <Button
            variant="tertiary"
            size="small"
            key={page}
            selected={page === currentPage}
            onClick={() => setCurrentPage(page)}
          >
            {page + 1}
          </Button>
        ))}
      </div>
      <Button
        variant="tertiary"
        size="small"
        disabled={currentPage === pageCount - 1}
        onClick={() => setCurrentPage(currentPage + 1)}
      >
        <NavigateRight />
      </Button>
    </div>
  );
};
